
import { Injectable } from '@angular/core';
import { ConfigService, MenuService } from 'esz-saas-lcp-ng-crud-ui';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CustomConfigService extends ConfigService {

    constructor(
        protected menuService: MenuService,
        public primengConfig: PrimeNGConfig
    ) {
        super(
            menuService,
            primengConfig,
        );

        // Configure CMS settings from environment
        this.cmsApiConfig = {
            cmsApiToken: environment.cmsApiToken,
            cmsApiUrl: environment.cmsApiUrl,
            cmsLocalUrl: environment.cmsLocalUrl,

            selectedContentLanguage: environment.selectedContentLanguage,
            languagePlaceholderMappings: environment.languagePlaceholderMappings,
        };

        this.config = {
            brand: environment.branding,
            layoutMode: 'static',
            layoutColor: 'light',
            dark: false,
            isRTL: true,
            inputStyle: 'outlined',
            ripple: true,

        };

        this.layouts = [];
        this.themes = [];

        // Dynamically generate brands array from environment configuration
        this.brands = this.generateBrandsFromEnvironment();
    }

    /**
     * Dynamically generates the brands array based on environment configuration
     * @returns Array of brand objects with image and label
     */
    private generateBrandsFromEnvironment(): { image: string; label: string }[] {
        const availableBrands = (environment as any).availableBrands || [environment.branding];
        const theme = this.config.dark ? 'dark' : 'light';

        return availableBrands.map((brandName: string) => ({
            image: `assets/layout/images/branding/${brandName}/logo-slim-${theme}.png`,
            label: brandName
        }));
    }
}

